import { COLLECT_LOGIN_DETAILS } from '../../../actions/digitalSavings/auth';
import { loginService } from './login';
import { TRIGGER_AGENT_TYPE } from '../../../actions/digitalSavings/agentModal';
import { getIntermeiaryAgent } from './agent';
import { COLLECT_QUOTE_FORM_DATA, COLLECT_SHARE_QUOTE_FORM_DATA } from '../../../actions/digitalSavings/quote';
import { premiumCalculationService } from './quote';
import { shareQuoteService } from './shareQuote';
import {
    CHECK_PAYMENTS_STATUS,
    PAYMENT_BANK_SUBMIT_SUCCESS,
    TRIGGER_CONFIRM_ORDER,
    TRIGGER_KE_PAYMENTS_STK_PUSH,
    TRIGGER_POLICY_NUMBER,
} from '../../../actions/digitalSavings/payment';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/digitalSavings/payloadCollection';
import { payloadSubmitService } from './payloadCollection';
import { orderConfirmationService } from './orderConfirmation';
import { policyNumberService } from './policyNumber';
import { COLLECT_PERSONAL_DETAILS_FORM } from '../../../actions/digitalSavings/personalDetails';
import { personalDetailsSubmit } from './personalDetails';
import { COLLECT_DOCUMENTS_FORM } from '../../../actions/digitalSavings/Documents';
import { documentsSubmit } from './documents';
import { COLLECT_BENEFICIARIES_FORM } from '../../../actions/digitalSavings/beneficiaries';
import { beneficiariesSubmit } from './beneficiary';
import {savePayments} from './bankPayments'

import { paystackPaymentService, submitPaymentService, paystackStkStatusService } from './paystack';
import {
    INITIATE_PAYMENT,
    PAYSTACK_SUBMIT_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
} from '../../../actions/digitalSavings/paystack';

export const digitalSavingsCover = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PERSONAL_DETAILS_FORM)) {
        return personalDetailsSubmit(store, next, action);
    }

    if (action.type.startsWith(COLLECT_DOCUMENTS_FORM)) {
        return documentsSubmit(store, next, action);
    }

    if (action.type.startsWith(COLLECT_BENEFICIARIES_FORM)) {
        return beneficiariesSubmit(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_KE_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }

    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }

    if (action.type.startsWith(PAYMENT_BANK_SUBMIT_SUCCESS)) {
        return savePayments(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_POLICY_NUMBER)) {
        return policyNumberService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_AGENT_TYPE)) {
        return getIntermeiaryAgent(store, next, action);
    }

    return null;
};
